"use client"

import { Box, Typography, Button, Paper } from "@mui/material"
import { motion } from "framer-motion"

const EmptyState = ({ title, description, actionText, actionIcon, onActionClick, icon }) => {
  return (
    <Paper
      component={motion.div}
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5 }}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 8,
        px: 4,
        textAlign: "center",
        borderRadius: 4,
        background: "linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(249, 250, 251, 0.9) 100%)",
        backdropFilter: "blur(8px)",
        border: "1px dashed rgba(99, 102, 241, 0.2)",
      }}
    >
      {icon && (
        <Box
          sx={{
            mb: 3,
            color: "primary.main",
            opacity: 0.7,
          }}
          component={motion.div}
          animate={{
            y: [0, -10, 0],
            opacity: [0.7, 1, 0.7],
          }}
          transition={{
            duration: 3,
            repeat: Number.POSITIVE_INFINITY,
            ease: "easeInOut",
          }}
        >
          {icon}
        </Box>
      )}

      <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
        {title}
      </Typography>

      <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: 500 }}>
        {description}
      </Typography>

      {actionText && onActionClick && (
        <Button
          variant="contained"
          startIcon={actionIcon}
          onClick={onActionClick}
          sx={{
            boxShadow: "0 4px 14px 0 rgba(99, 102, 241, 0.39)",
            "&:hover": {
              boxShadow: "0 6px 20px rgba(99, 102, 241, 0.5)",
              transform: "translateY(-2px)",
            },
          }}
        >
          {actionText}
        </Button>
      )}
    </Paper>
  )
}

export default EmptyState

